import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { AfterViewInit, Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { IEntity } from '@interfaces/entity';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PricingsService } from '@services/entity/pricings.service';
import { FormService } from '@services/form/form.service';

@Component({
  selector: 'app-create-pricing-dialog-content',
  templateUrl: './create-pricing-dialog-content.component.html',
  styleUrls: ['./create-pricing-dialog-content.component.scss']
})
export class CreatePricingDialogContentComponent extends AbstractDialogContent implements OnInit, AfterViewInit {

  public className = 'CreatePricingDialogContentComponent';
  public customerId: number
  public isSupporter: boolean = false;

  @ViewChild('createPricingComponent') createPricingComponent;

  constructor(
    public activeModal: NgbActiveModal,
    public pricingsService: PricingsService,
    public formService: FormService,
    injector: Injector) {
    super(activeModal, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.isSupporter = this.authenticationService.userHasRole('Supporter');
  }

  ngAfterViewInit() {
  }

  newEntityEvent(entity: IEntity) {
    this.activeModal.close();
  }
}
